import { updates } from '@/mocks/homepage';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            快讯动态
          </h2>
          <p className="text-sm text-foreground-500">
            漫画圈最新鲜的资讯，第一时间为你送达
          </p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300 hidden md:block"></div>

          <div className="space-y-5">
            {updates.map((item, idx) => (
              <div key={idx} className="relative flex items-start gap-5 pl-0 md:pl-14">
                {/* Timeline dot */}
                <div className="hidden md:flex absolute left-[11px] top-1.5 w-[17px] h-[17px] rounded-full border-2 border-primary-500 bg-background-100 items-center justify-center">
                  <div className="w-[7px] h-[7px] rounded-full bg-primary-500"></div>
                </div>

                {/* Content */}
                <div className="flex-1 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-[11px] text-foreground-400 flex-shrink-0">{item.date}</span>
                    <span className={`px-2 py-0.5 text-[10px] font-medium rounded-full flex-shrink-0 ${
                      item.tag === '更新' ? 'bg-primary-100 text-primary-600' :
                      item.tag === '新作' ? 'bg-accent-100 text-accent-600' :
                      item.tag === '动画化' ? 'bg-secondary-100 text-secondary-700' :
                      item.tag === '排行' ? 'bg-primary-50 text-primary-500' :
                      item.tag === '完结' ? 'bg-background-200 text-foreground-600' :
                      'bg-accent-50 text-accent-500'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}